import type { Values } from '@web-platform/shared-universal-types-utils/src/utils';

export const ASSESSMENT_TYPE = {
  ASSESSMENT_UNSPECIFIED: 'UNKNOWN',
  ASSESSMENT_INCLUDED: 'INCLUDED',
  ASSESSMENT_FEE: 'FEE',
  ASSESSMENT_UNAVAILABLE: 'UNAVAILABLE',
} as const;

export type AssessmentType = Values<typeof ASSESSMENT_TYPE>;
